import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  AdminUserInTableMenu,
  ReactTableFilterAzSearch,
  ReactTableFilterDatePicker,
  ReactTableFilterDropdown,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  Loading
} from 'components';
import { Icon, Image } from 'semantic-ui-react';
import * as commonVar from 'libs/commonVar';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './AdminUserList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class AdminUserList extends PureComponent {
  render() {
    const { formatMessage } = this.props.intl;
    const { isAuth, data, fromNowClass, fromNowView, handleChangeDateFilter, ...rest } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const {
      userEnabledFilter,
      userActivedFilter,
      loginFailFilter,
      cancleCheck,
      filterClose,
      executeFilter,
      onFilterCancel,
      // 교육 활성 여부
      isEdu
    } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const columns = [
      {
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 88,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          return <AdminUserInTableMenu isAuth={isAuth} userInfo={{ ...original }} />;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_1', defaultMessage: '서비스No' }))}
          />
        ),
        accessor: 'serviceNo',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td text-align-center number-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminUserList_8', defaultMessage: '서비스명' }))}
          />
        ),
        accessor: 'serviceName',
        sortable: true,
        minWidth: 143,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text')
      },
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'userNo',
        sortable: true,
        resizable: false,
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminUserList_1', defaultMessage: '이름' }))}
          />
        ),
        accessor: 'userName',
        sortable: true,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminUserList_2', defaultMessage: '이메일' }))}
          />
        ),
        accessor: 'userEmail',
        sortable: true,
        minWidth: 177,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminUserList_3', defaultMessage: '연락처' }))}
          />
        ),
        accessor: 'userPhone',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text')
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'UserEdit_17', defaultMessage: '잠김' })),
              value: '1'
            },
            { key: '0', text: defineMessages(formatMessage({ id: 'UserEdit_14', defaultMessage: '정상' })), value: '0' }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminUserList_17', defaultMessage: '로그인 실패' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'loginFail',
        id: 'loginFail',
        sortable: true,
        resizable: false,
        width: 120,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text')
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [{ key: '1', text: 'O', value: '1' }, { key: '0', text: '-', value: '0' }];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminUserList_4', defaultMessage: '활성' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'userActived',
        id: 'userActived',
        sortable: true,
        resizable: false,
        width: 80,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = 'O';
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [{ key: '0', text: 'O', value: '0' }, { key: '1', text: '-', value: '1' }];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminUserList_7', defaultMessage: '삭제 여부' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'userEnabled',
        id: 'userEnabled',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 0) {
            printValue = 'O';
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminUserList_18', defaultMessage: '공유 서비스' }))}
          />
        ),
        accessor: 'sharedServiceNameArray',
        sortable: false,
        minWidth: 172,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text'),
        Cell: ({ value }) => {
          return !!value ? <div title={value.join(', ')}>{value.join(', ')}</div> : '-';
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminUserList_9', defaultMessage: '비밀번호 변경일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('PasswdUpdateEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'passwdUpdateEpoch',
        width: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('passwd-update-date-normal')}>
                {moment.unix(value).format(dateFormat + ' HH:mm:ss')}
              </span>
              <span className={cx('passwd-update-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminUserList_10', defaultMessage: '가입일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        width: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      }
    ];

    if (isEdu === 1) {
      columns.splice(9, 0, {
        Header: (
          <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'Edu_12', defaultMessage: '교육' }))} />
        ),
        accessor: 'isEdu',
        id: 'isEdu',
        sortable: true,
        resizable: false,
        width: 83,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = 'O';
          }
          return printValue;
        }
      });
    }

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('react-table-area', fromNowClass.join(' '))}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            userEnabledFilter: userEnabledFilter,
            userActivedFilter: userActivedFilter,
            loginFailFilter: loginFailFilter
          }}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'userNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(formatMessage({ id: 'AdminUserList_13', defaultMessage: '데이터 로딩중...' }))}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                      className: filter.join(' ')
                    }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original && rowInfo.original.userEnabled === 0) {
                return {
                  className: 'delete-item'
                };
              } else {
                return {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(AdminUserList);



// WEBPACK FOOTER //
// ./src/script/components/admin/user/AdminUserList.js